<template>
    <div>

        <config-main-title>
            Regras de Rateio
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'" :disabled="pode_ordenar">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'" :disabled="pode_ordenar">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Regra
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                msg="Nenhuma Regra de Rateio identificada." 
                icon="fas fa-search"
                :action="'Incluir Regra de Rateio'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <ordenacao-dragn-drop :disabled="viewMode == 'T'" v-model="pode_ordenar" :search="search" />

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <draggable v-model="exibicao" @start="drag=true" @end="drag=false; atualizarOrdem($event);" ghost-class="primary" 
                    :draggable="( search || !pode_ordenar ) ? '.none' : '.list-group-item'">
                    <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in exibicao" :key="id">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>
                            <span class="badge badge-secondary">
                                {{ dado.ident }}
                            </span>
                            <span class="badge ml-3" :class="'badge-' + ( dado.ch_tipo_repasse == 'R' ? 'success' : ( dado.ch_tipo_repasse == 'F' ? 'primary' : 'secondary' ) )"
                                :title="( dado.ch_tipo_repasse == 'R' ? 'Recebido' : ( dado.ch_tipo_repasse == 'F' ? 'Faturado/Pago' : 'Produzido' ) )">
                                {{ dado.ch_tipo_repasse }}
                            </span>

                            <span v-if="dado.fl_recorrente" class="text-muted"
                                data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                                <i class="fas fa-sync"></i>
                            </span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + dado.id_rateio_medico" 
                                    :key="'A'+ id"
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + dado.id_rateio_medico"></label>
                            </div>
                            <div class="d-flex" v-else>
                                {{ dado.info_rateio }}

                                <span class="badge badge-secondary ml-2" title="Número de Ordem das Regras.">{{ dado.in_regra_ordem }}</span>
                            </div>
                        </span>
                    </li>
                </draggable>
            </div>

        </div>

        <edicao-rateio-medico ref="editarrateio" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EdicaoRateioMedico from '../shared/EdicaoRateioMedico.vue';
import draggable from "vuedraggable";
import OrdenacaoDragnDrop from '../shared/OrdenacaoDragnDrop.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            drag: false, 
            pode_ordenar: false, 
            exibicao: [],
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        EdicaoRateioMedico,
        draggable,
        OrdenacaoDragnDrop
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\operadora', search:'Operadora'}, 
                {id:'App\\azure\\medico', search:'Prestador'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento'}
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade'});
            }
            
            return opcoes;
        }
    },

    watch: { 
        dados: { 
            handler: function () {
                this.filtrar();
            },
            deep: true,
            immediate: true
        },

        viewMode: { 
            handler: function () {
                this.filtrar();
            },
            deep: true,
            immediate: true
        },

        search: { 
            handler: function () {
                this.filtrar();
            },
            deep: true,
            immediate: true
        }
    },

    methods: { 
        filtrar () { 
            this.exibicao = this.viewMode == 'T' ? this.lista : _.cloneDeep(this.lista);
        },

        atualizarOrdem () { 

            this.$util.atualizar(this, { 
                service: 'rateio_medicos', 
                func: 'ordem',
                dados: {
                    lista: this.exibicao
                },
                toast: true, 
                reload: true, 
            });
            
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },
        incluir_filtro(item) { 
            item.filtros.push({ 
                id_teto_atendimento_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.$refs.editarrateio.incluir();
        },
        load () { 
            this.$util.load(this, { 
                service:'rateio_medicos',
                func: 'index',
                parms: { 
                    cadastro_geral: true,  
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.$refs.editarrateio.editar(item.id_rateio_medico);
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'rateio_medicos',
                dados: item,
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Regras de Rateio", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>